import { Injectable } from '@angular/core';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';

@Injectable()
export class BoxInfoTruckService {

  infoTruck: any;
  infoTrajeto: any;

  constructor
  (
    private boxListTruckService: BoxListTruckService
  ) 
  { }

  async getInfoTruck() 
  {
    try 
    {
      let dados = this.boxListTruckService.listTruckService.find(x => x.roteiro == this.boxListTruckService.roteiroSelecionado);      
      return dados;
    }
    catch (Error)
    {
      console.log('BoxInfoTruckService');
      console.log(Error);
    }
  }
}